import DesktopReg from "./DesktopReg"

export default  DesktopReg;
